import styled, { css } from 'styled-components';
import { ChevronDownProps, PositionerProps } from './types';
import ChevronDownDefault from '~components/svgs/ChevronDown';

export const ChevronDown = styled(ChevronDownDefault)<ChevronDownProps>`
  position: absolute;
  right: ${({ theme }) => theme.spacing.km4};
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: ${({ theme }) => theme.color.icon.neutral.default};

  svg {
    transition: 200ms ease;
  }

  ${({ $rotate }) =>
    $rotate &&
    css`
      svg {
        transform: rotateZ(180deg);
      }
    `}
`;

export const Wrapper = styled.div`
  position: relative;

  input:focus + svg {
    color: ${({ theme }) => theme.color.icon.neutral.strong};
  }

  input {
    cursor: pointer;
    caret-color: transparent;
  }
`;

export const Positioner = styled.div<PositionerProps>`
  position: absolute;
  width: 100%;
  z-index: 1;
`;
